/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Dashboard_Booking_Request_CountInputs */

const en_admin_dashboard_booking_request_count = /** @type {(inputs: Admin_Dashboard_Booking_Request_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} booking request`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} booking requests`);
	return /** @type {LocalizedString} */ ("admin.dashboard.booking_request_count");
};

const de_admin_dashboard_booking_request_count = /** @type {(inputs: Admin_Dashboard_Booking_Request_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} Buchungsanfrage`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} Buchungsanfragen`);
	return /** @type {LocalizedString} */ ("admin.dashboard.booking_request_count");
};

const es_admin_dashboard_booking_request_count = /** @type {(inputs: Admin_Dashboard_Booking_Request_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} solicitud de reserva`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} solicitudes de reserva`);
	return /** @type {LocalizedString} */ ("admin.dashboard.booking_request_count");
};

const fr_admin_dashboard_booking_request_count = /** @type {(inputs: Admin_Dashboard_Booking_Request_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} Demande de réservation`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} Demandes de réservation`);
	return /** @type {LocalizedString} */ ("admin.dashboard.booking_request_count");
};

const nl_admin_dashboard_booking_request_count = /** @type {(inputs: Admin_Dashboard_Booking_Request_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} reserveringsverzoek`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} reserveringsverzoeken`);
	return /** @type {LocalizedString} */ ("admin.dashboard.booking_request_count");
};

const pt_br2_admin_dashboard_booking_request_count = /** @type {(inputs: Admin_Dashboard_Booking_Request_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} solicitação de reserva`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} solicitações de reserva`);
	return /** @type {LocalizedString} */ ("admin.dashboard.booking_request_count");
};

/** @type {(inputs: Admin_Dashboard_Booking_Request_CountInputs) => LocalizedString} */
const it_admin_dashboard_booking_request_count = en_admin_dashboard_booking_request_count;

/** @type {(inputs: Admin_Dashboard_Booking_Request_CountInputs) => LocalizedString} */
const pl_admin_dashboard_booking_request_count = en_admin_dashboard_booking_request_count;

/** @type {(inputs: Admin_Dashboard_Booking_Request_CountInputs) => LocalizedString} */
const hu_admin_dashboard_booking_request_count = en_admin_dashboard_booking_request_count;

/** @type {(inputs: Admin_Dashboard_Booking_Request_CountInputs) => LocalizedString} */
const ro_admin_dashboard_booking_request_count = en_admin_dashboard_booking_request_count;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} booking request" |
* | "other" | "{count} booking requests" |
*
* @param {Admin_Dashboard_Booking_Request_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_booking_request_count = /** @type {((inputs: Admin_Dashboard_Booking_Request_CountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Booking_Request_CountInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_booking_request_count(inputs)
	if (locale === "de") return de_admin_dashboard_booking_request_count(inputs)
	if (locale === "es") return es_admin_dashboard_booking_request_count(inputs)
	if (locale === "fr") return fr_admin_dashboard_booking_request_count(inputs)
	if (locale === "nl") return nl_admin_dashboard_booking_request_count(inputs)
	if (locale === "it") return it_admin_dashboard_booking_request_count(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_booking_request_count(inputs)
	if (locale === "pl") return pl_admin_dashboard_booking_request_count(inputs)
	if (locale === "hu") return hu_admin_dashboard_booking_request_count(inputs)
	return ro_admin_dashboard_booking_request_count(inputs)
});
export { admin_dashboard_booking_request_count as "admin.dashboard.booking_request_count" }